document.querySelectorAll('.atelier-search').forEach(dialog => {
  const input = dialog.querySelector('input[type="search"]');
  const output = dialog.querySelector('.ingrid-predictive');
  if (!input || !output || input.dataset.predictiveReady) return;
  input.dataset.predictiveReady = 'true';
  let timer, controller;
  input.addEventListener('input', () => {
    clearTimeout(timer); controller?.abort();
    const query = input.value.trim();
    output.hidden = true;
    if (!query) { output.replaceChildren(); return; }
    timer = setTimeout(async () => {
      controller = new AbortController();
      const params = new URLSearchParams({ q: query, section_id: 'ingrid-predictive', 'resources[type]': 'product,query', 'resources[limit]': '4', 'resources[limit_scope]': 'each' });
      try {
        const response = await fetch(`${output.dataset.endpoint}?${params}`, { signal: controller.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('.ingrid-predictive-content');
        if (input.value.trim() !== query || !content) return;
        output.replaceChildren(content); output.hidden = false;
      } catch (error) {
        if (error.name !== 'AbortError') output.hidden = true;
      }
    }, 180);
  });
  dialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowDown' && event.target === input && !output.hidden) { event.preventDefault(); output.querySelector('a')?.focus(); }
    if (event.key === 'Tab') {
      const focusable = [...dialog.querySelectorAll('input:not([type="hidden"]),button,a')].filter(el => el.getClientRects().length);
      const first = focusable[0], last = focusable.at(-1);
      if (event.shiftKey && event.target === first) { event.preventDefault(); last?.focus(); }
      if (!event.shiftKey && event.target === last) { event.preventDefault(); first?.focus(); }
    }
  });
});
